<template>
  <div
    :class="{
      [$style.dark]: settings.menuColor === 'dark',
    }"
  >
    <div :class="$style.logoContainer">
      <a-icon
        type="appstore"
        @click="visible = !visible"
        :class="[$style.appIcon, 'mr-3']"
        style="font-size: 2rem;"
      />
      <div :class="$style.logo">
        <img
          :src="logoUrl"
          class="mr-3"
          :alt="companyName"
          style="height: 40px;"
        />
        <div :class="$style.name">
          <router-link to="/">{{ settings.logo }}</router-link>
        </div>
      </div>
      <a-drawer
        placement="left"
        @close="onCloseDrawer"
        :closable="false"
        :visible="visible"
        width="320"
      >
        <div style="margin-top: -18px;">
          <div :class="$style.logoContainer">
            <a-icon
              type="appstore"
              @click="visible = !visible"
              :class="[$style.appIcon, 'mr-3']"
              style="font-size: 2rem;"
            />
            <div :class="$style.logo" @click="visible = !visible">
              <!-- <img
                :src="logoUrl"
                class="mr-2"
                alt="ICT24H"
                style="width: 45px;"
              /> -->
              <div :class="$style.name">
                {{ settings.logo }}
              </div>
              <div v-if="settings.logo === 'ICT24H'" :class="$style.descr">
                {{ companyName }}
              </div>
            </div>
          </div>
        </div>
        <div class="mt-4">
          <ListApp />
        </div>
      </a-drawer>
    </div>
  </div>
</template>
<style lang="scss" module>
@import "./style.module.scss";
</style>
<script>
import { mapState } from "vuex";
import Query from "./query";

import ListApp from "./ListApp/index.vue";

export default {
  components: { ListApp },
  methods: {
    onCloseDrawer() {
      this.visible = false;
    },
  },
  data() {
    return {
      logoUrl: "resources/images/logo.png",
      companyName: "ICT24H",
      visible: false,
      getAppConfigOrganization: {},
    };
  },
  computed: {
    ...mapState(["settings"]),
  },
  watch: {
    getAppConfigOrganization: function (val) {
      if (val.logoUrl) {
        this.logoUrl = val.logoUrl;
      }
      if (val.name) {
        this.companyName = val.name;
      }
    },
  },
  created() {
    // Lấy dữ liệu về
    this.$apollo.addSmartQuery("getAppConfigOrganization", {
      query: Query.getAppConfigOrganization,
    });
  },
};
</script>
